/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4de78036&scoped=true&ts=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4de78036&scoped=true&lang=sass"

import exportComponent from "/Users/boringtu/Workspace/pri/kangxt-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de78036"]])

export default __exports__